var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useGlobalContext } from '@honeycomb/data';
import { Avatar, Button, ControlIcon, Skeleton } from '@honeycomb/ui-core';
import React from 'react';
import { useAppliedFiltersCount } from '../useAppliedFiltersCount';
export function FiltersButton(_a) {
    var { product, loading, AvatarProps: AvatarPropsProp, version = 'default' } = _a, other = __rest(_a, ["product", "loading", "AvatarProps", "version"]);
    const { resourceStrings: { SRP_FILTERBUTTON_LABEL, SRP_FILTERBUTTON_LABEL_SHORT }, } = useGlobalContext();
    const appliedFiltersCount = useAppliedFiltersCount(product);
    if (loading) {
        return (React.createElement(Skeleton, { radius: 10 },
            React.createElement(Button, { icon: React.createElement(ControlIcon, null) }, SRP_FILTERBUTTON_LABEL)));
    }
    const isMapOverlayVariant = version === 'map-overlay';
    return (React.createElement(Button, Object.assign({ size: isMapOverlayVariant ? 'm' : 's', color: isMapOverlayVariant ? 'white' : 'primary', icon: React.createElement(ControlIcon, null), decoration: appliedFiltersCount ? (React.createElement(Avatar, { color: isMapOverlayVariant ? 'text.body' : 'common.white', textColor: isMapOverlayVariant ? 'common.white' : 'primary.base', size: isMapOverlayVariant ? 'm' : 's' }, appliedFiltersCount)) : undefined, pr: appliedFiltersCount > 0 ? 3 : undefined, boxShadow: isMapOverlayVariant ? 'm' : undefined, br: isMapOverlayVariant ? 16 : undefined, "data-id": "filters-button", disabled: loading }, other), isMapOverlayVariant ? SRP_FILTERBUTTON_LABEL_SHORT : SRP_FILTERBUTTON_LABEL));
}
